import { render } from "./CertificateCatalog.vue?vue&type=template&id=d5cf2d2c&scoped=true"
import script from "./CertificateCatalog.vue?vue&type=script&lang=js"
export * from "./CertificateCatalog.vue?vue&type=script&lang=js"

import "./CertificateCatalog.vue?vue&type=style&index=0&id=d5cf2d2c&lang=css"
import "./CertificateCatalog.vue?vue&type=style&index=1&id=d5cf2d2c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cf2d2c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
